import { CardIconOne, CardIconThree, CardIconTwo } from "assets";
import carouselCard from "assets/images/carousel-card.png";

interface PartnerCard {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
}

const partnerCards: PartnerCard[] = [
  {
    icon: CardIconTwo,
    title: "Talent Strategy",
    description:
      "Design the structures, roles, and talent systems needed to support growth.",
  },
  {
    icon: CardIconOne,
    title: "Performance Systems",
    description:
      "Build accountability, improve execution, and create consistency in how performance is managed.",
  },
  {
    icon: CardIconThree,
    title: "Talent Intelligence",
    description:
      "Use assessments and behavioral insights to make better decisions about hiring, development, and team effectiveness.",
  },
];

const WorkWithPartner = () => {
  const handleBookConsultation = () => {
    window.open(
      "https://calendly.com/precisionmatch/talent-enablement-consultation",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div data-aos="fade-up" className="mt-12 md:mt-16">
      {/* Header */}
      <div className="mx-auto max-w-[720px] text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-[#050B17] mb-4">
          Build Better Teams with Expert Guidance
        </h2>
        <p className="text-base md:text-lg lg:text-xl text-[#475467]">
          Get hands-on support to design the structures, accountability systems,
          and talent strategies that help teams perform at their highest level.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 sm:gap-8 gap-2">
        {partnerCards.map((card, index) => (
          <div
            key={card.title}
            data-aos="fade-up"
            data-aos-delay={100 + index * 100}
            className="m-[20px] mt-[60px] mr-[60px]"
            style={{
              border: "0px solid transparent",
              borderImageSource: `url(${carouselCard})`,
              borderImageSlice: "60 60 20 20 fill",
              borderImageWidth: "60px 60px 20px 20px",
              borderImageOutset: "30px 60px 30px 30px",
            }}
          >
            <div className="sm:w-14 sm:h-14 w-12 h-12 bg-[#292EBB] rounded-xl flex items-center justify-center mb-14">
              <card.icon className="w-6 h-6 md:w-7 md:h-7 text-white" />
            </div>
            <h3 className="text-lg md:text-2xl font-bold text-[#1D2939] mb-3">
              {card.title}
            </h3>
            <p className="text-sm md:text-lg text-[#475467] leading-relaxed">
              {card.description}
            </p>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="mt-12 flex justify-center">
        <button
          onClick={handleBookConsultation}
          className="px-8 py-4 bg-[#012169] hover:bg-[#011550] text-white text-base font-semibold rounded-[10px] transition-all duration-200 hover:shadow-lg"
        >
          Book a Consultation Session
        </button>
      </div>
    </div>
  );
};

export { WorkWithPartner };
